import React from 'react';
import { Heading } from '../../../components';
import { treeIntro, images } from '../../../constants'; // Upewnij się, że masz treeIntro w constants
import { FaTree } from 'react-icons/fa'; // Zmieniłem ikonę na drzewo
import './TreeIntro.css';

const TreeIntro = () => {
    return (
        <section className='tree-intro'>
            <div className='content'>
                {/* Zakładam strukturę danych taką samą jak w careerIntro */}
                <Heading title={treeIntro.heading} subTitle={treeIntro.sub} sideHeading={true} />
                <p>{treeIntro.description}</p>
                <ul className="tree-features">
                    {treeIntro.points.map((point, index) => (
                        <li key={index}>
                            <FaTree className="icon" />
                            <span>{point}</span>
                        </li>
                    ))}
                </ul>
            </div>
            <div className='image'>
                {/* Pamiętaj, aby zmienić zdjęcie na odpowiednie dla Tree */}
                <img src={images.tree2} alt='Tree-Pic' />
            </div>
        </section>
    );
};

export default TreeIntro;